// extracted by mini-css-extract-plugin
export default {"main":"LoadingModal_main__FoL-u"};